export default __webpack_public_path__ + "static/media/info-circle-icon.1aca0949.svg";